// PRD 10 §4.2 — Status / Publish-date cell.
//   PUBLISHED → single green "게시중 YYYY.MM.DD" pill (status + publish date on one
//               line, matching the prototype `statusBadge`; SHCT-471).
//   DRAFT     → neutral "임시저장" badge, no date.

import { useTranslation } from 'react-i18next';

import type { ContentSummary } from '../types/health-encyclopedia.types';

interface EncyclopediaStatusBadgeProps {
  content: Pick<ContentSummary, 'status' | 'publishedAt'>;
}

export function EncyclopediaStatusBadge({ content }: EncyclopediaStatusBadgeProps) {
  const { t } = useTranslation('health-encyclopedia');

  if (content.status === 'PUBLISHED') {
    // Status label + date inside one green pill (badge text is `white-space: nowrap`
    // so it never wraps to a second line). Date omitted when not yet recorded.
    const label = content.publishedAt
      ? `${t('statuses.published')} ${content.publishedAt}`
      : t('statuses.published');
    return <span className="badge badge-success">{label}</span>;
  }

  return (
    <span className="badge" style={{ background: 'var(--muted)', color: 'var(--muted-foreground)' }}>
      {t('statuses.draft')}
    </span>
  );
}
